"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Effect_Radiance_OnAttackEventHandlerScript = void 0;
const EventType_1 = require("../../core/events/EventType");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
let Effect_Radiance_OnAttackEventHandlerScript = class Effect_Radiance_OnAttackEventHandlerScript {
    run(sequence, container, handler, event) {
        if (event.args.__type !== EventType_1.EventType.Attack) {
            return;
        }
        for (const allyId of container.selectLivingTargets(event.subject, Target_1.Target.AllAllies)) {
            container.applyHealing({
                sequence,
                healerId: event.subject,
                targetId: allyId,
                amount: 2 * container.getLevel(event.subject)
            });
        }
    }
};
Effect_Radiance_OnAttackEventHandlerScript = __decorate([
    Registries_1.EventHandlerScripts.register("Effect_Radiance_OnAttack")
], Effect_Radiance_OnAttackEventHandlerScript);
exports.Effect_Radiance_OnAttackEventHandlerScript = Effect_Radiance_OnAttackEventHandlerScript;
